__turbopack_context__.v({
  "className": "caveat_21f1d7d-module___9IIta__className",
  "variable": "caveat_21f1d7d-module___9IIta__variable",
});
